import InfoTooltip from './view';

export default InfoTooltip;
